module.exports = __webpack_public_path__ + "img/mo_com2.6e11bd37.png";